import gql from "graphql-tag";
import { ACFMediaFragment } from "@/fragments";
import { SonicConnectionsFragment } from "@/fragments/Posts/SonicConnections";
import { PageDataFragment } from "@/fragments/PageData";

export const PostQuery = gql`
  ${ACFMediaFragment}
  ${SonicConnectionsFragment}
  ${PageDataFragment}
  query GetPost($databaseId: ID!, $asPreview: Boolean, $language: String!) {
    rhPost(id: $databaseId, asPreview: $asPreview, language: $language) {
      ...PageData
      title
      date
      author {
        node {
          name
        }
      }
      pageData {
        featuredImage {
          ...ACFMedia
        }
      }
      featureData {
        excerpt
        sonicConnections {
          ...SonicConnections
        }
      }
    }
  }
`;
